var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportPending(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 201,
    height: 188,
    fill: "none",
    viewBox: "0 0 201 188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6dae2",
    d: "M50.68 30.533s30.023 21.733 75.667-18.903c40.536-36.086 73.635 20.85 73.866 48.117.3 35.32-40.536 63.582-20.718 86.781s-39.302 61.508-71.164 28.354c-39.636-41.243-50.373-7.733-72.965-7.733-16.215 0-49.505-38.429-27.025-67.019 18.917-24.058 8.6-32.042 3.604-40.383-7.207-12.03 9.908-44.68 38.734-29.214",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#515c6f",
    strokeWidth: 5.107,
    d: "M152.034 56.55v78.658c0 4.722-3.455 8.55-7.716 8.55H52.501c-4.261 0-7.716-3.828-7.716-8.55V56.55m107.249 0c0-4.722-3.455-8.55-7.716-8.55H52.501c-4.261 0-7.716 3.828-7.716 8.55m107.249 0v17.1H44.785v-17.1m70.985 16.244v69.254M81.049 72.794v69.254m70.985-23.085H44.785m107.249-23.084H44.785"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 61,
    height: 84,
    x: 120.775,
    y: 53.768,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M120.775 53.768h61v84h-61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.088 63.96a3.192 3.192 0 1 1 6.384 0v56.133l14.865-14.865a3.192 3.192 0 0 1 4.513 4.514l-20.313 20.313a3.19 3.19 0 0 1-4.514 0l-20.313-20.313a3.192 3.192 0 0 1 4.513-4.514l14.865 14.865z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#556e98",
    d: "M148.088 63.96a3.192 3.192 0 1 1 6.384 0v56.133l14.865-14.865a3.192 3.192 0 0 1 4.513 4.514l-20.313 20.313a3.19 3.19 0 0 1-4.514 0l-20.313-20.313a3.192 3.192 0 0 1 4.513-4.514l14.865 14.865z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eff0f3",
    d: "M148.088 63.96h6.384zm3.192-3.192v-6.384zm3.192 3.192h6.384zm0 56.133h-6.384v15.412l10.898-10.898zm14.865-14.865-4.514-4.515v.001zm4.513 0 4.514-4.514zm0 4.514 4.514 4.514.001-.001zm-20.313 20.313 4.514 4.514zm-4.514 0-4.514 4.514zm-20.313-20.313-4.515 4.513.001.001zm0-4.514-4.514-4.514zm4.513 0 4.514-4.514v-.001zm14.865 14.865-4.514 4.514 10.898 10.898v-15.412zm0-56.133h6.384a3.19 3.19 0 0 1-3.192 3.192V54.384c-5.288 0-9.576 4.287-9.576 9.576zm3.192-3.192v6.384a3.19 3.19 0 0 1-3.192-3.192h12.768a9.576 9.576 0 0 0-9.576-9.576zm3.192 3.192h-6.384v56.133h12.768V63.96zm0 56.133 4.514 4.514 14.865-14.865-4.514-4.514-4.514-4.514-14.865 14.865zm14.865-14.865 4.513 4.515a3.193 3.193 0 0 1-4.514-.001l4.514-4.514 4.514-4.514c-3.74-3.74-9.802-3.739-13.541-.001zm4.513 0-4.514 4.514a3.19 3.19 0 0 1 0-4.514l4.514 4.514 4.515 4.513c3.738-3.739 3.74-9.801-.001-13.541zm0 4.514-4.514-4.515-20.313 20.314 4.514 4.514 4.514 4.514 20.313-20.313zm-20.313 20.313-4.514-4.514a3.193 3.193 0 0 1 4.514 0l-4.514 4.514-4.514 4.514a9.575 9.575 0 0 0 13.542 0zm-4.514 0 4.514-4.514-20.313-20.314-4.514 4.515-4.514 4.514 20.313 20.313zm-20.313-20.313 4.514-4.514a3.19 3.19 0 0 1 0 4.514l-4.514-4.514-4.514-4.514a9.575 9.575 0 0 0-.001 13.541zm0-4.514 4.514 4.514a3.193 3.193 0 0 1-4.514.001l4.513-4.515 4.514-4.515c-3.739-3.737-9.801-3.74-13.541.001zm4.513 0-4.514 4.514 14.865 14.865 4.514-4.514 4.514-4.514-14.865-14.865zm14.865 14.865h6.384V63.96h-12.768v56.133z",
    mask: "url(#a)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportPending);
export default __webpack_public_path__ + "static/media/report-pending.fbd9882abcbb41c9362c576844e21718.svg";
export { ForwardRef as ReactComponent };